import axios from "axios";
import { nordNxtApiEndpoint } from "../../config/config";
import getAuthHeader from "../../utils/getAuthHeader";

export default async function updateOnboardingStatus(updateOnboardingStatusParams: {
  status: string;
  isWeb: boolean;
}) {
  const { data } = await axios.post(
    `${nordNxtApiEndpoint}/user-onboarding-status`,
    updateOnboardingStatusParams,
    getAuthHeader(),
  );
  return data;
}
